
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'General',
	'widgetId': 'ID de widget',
	'widgetType': 'Tipo de widget',
	'serviceability': 'Servicio',
	'copyButton': 'Copiar',
	'closeButton': 'Cerrar',
	'specification': 'Especificación',
	'viewSpecification': 'Ver especificación'
});
